<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Recognition :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/recognition-list">
                            <i class="fa fa-trophy"></i> Recognitions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/employees/recognition-list#settings">
                            Settings
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="recognition_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> Add</template>
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.recognition_name}">Recognition Name:</label>
                                <div class="col-md-5 col-sm-8">
                                    <input type="text" name="recognition_name" v-model="recognition.recognition_name" class="form-control" placeholder="Enter Recognition Type" :class="{'is-invalid': errors.recognition_name}" />
                                    <span v-if="errors.recognition_name" class="text-danger">
                                        <span v-for="error in errors.recognition_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveRecognition(this)" :disabled="saving">
                Save Recognition
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                recognition_id: this.$route.params.id,
                recognition: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getRecognition: function() {
                //Get the data
                this.$http
                    .get('admin/recognitions-edit' + (this.recognition_id ? '/' + this.recognition_id : ''))
                    .then(response => {
                        //Set all the data
                        this.recognition = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveRecognition: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/recognitions-edit' + (this.recognition_id ? '/' + this.recognition_id : ''), this.recognition)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Recognition Saved');

                    //Return to main list?
                    this.$router.push('/employees/recognition-list#settings');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getRecognition();
        }
    }
</script>
